const nodeTypeIs =
    (type: number) =>
    (node: Node): boolean =>
        node.nodeType === type;

export const isElement = nodeTypeIs(1);

export const isText = nodeTypeIs(3);

export const isCdata = nodeTypeIs(4);

export const getChildren = (
    node: Node,
    filter: (node: Node) => boolean
): Node[] => Array.prototype.filter.call(node.childNodes, filter);

const isTextOrCdata = (node: Node): boolean => isText(node) || isCdata(node);

export const getText = (node: Node): string =>
    getChildren(node, isTextOrCdata)
        .map((child) => child.nodeValue)
        .join('')
        .trim();
